import React from 'react'

const SvgBellFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M18 16V9.961a5.95 5.95 0 00-4-5.621V4a2 2 0 10-4 0v.362a6.032 6.032 0 00-4 5.677V16H5c-.667 0-1 .333-1 1s.333 1 1 1h14c.667 0 1-.333 1-1s-.333-1-1-1h-1zm-8 4a2 2 0 004 0h-4z' />
  </svg>
)

export default SvgBellFilled
